import api from "@/services/api";
import type {
  AnalysisOverridePayload,
  AnalysisOverrideTarget,
  AnalysisRun,
  AnalysisRunListItem,
  CreateAnalysisRunPayload,
} from "@/types/analysisRun";

export const analysisRunsService = {
  list: (borrowerId: number) =>
    api
      .get<AnalysisRunListItem[]>("/ai-services/analysis-runs/", {
        params: { borrower_id: borrowerId },
      })
      .then((r) => r.data),
  get: (id: number) =>
    api.get<AnalysisRun>(`/ai-services/analysis-runs/${id}/`).then((r) => r.data),
  // Async pipeline: POST returns immediately with status=processing; poll get().
  create: (payload: CreateAnalysisRunPayload) =>
    api.post<AnalysisRun>("/ai-services/analysis-runs/", payload).then((r) => r.data),
  // Revokes the run's Celery tasks (best-effort) and marks it error.
  stop: (runId: number) =>
    api.post<AnalysisRun>(`/ai-services/analysis-runs/${runId}/stop/`).then((r) => r.data),
  // Corrections are stored against the borrower, so both of these recompute the
  // run synchronously (no AI cost) and return it with corrected figures.
  saveOverride: (runId: number, payload: AnalysisOverridePayload) =>
    api
      .post<AnalysisRun>(`/ai-services/analysis-runs/${runId}/overrides/`, payload)
      .then((r) => r.data),
  clearOverride: (runId: number, target: AnalysisOverrideTarget) =>
    api
      .delete<AnalysisRun>(`/ai-services/analysis-runs/${runId}/overrides/`, { data: target })
      .then((r) => r.data),
};
